declare namespace $ {

	type $mol_paragraph__title_arch_app_1 = $mol_type_enforce<
		ReturnType< $arch_app['initial_length'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_labeler__title_arch_app_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_arch_app_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_string__value_arch_app_4 = $mol_type_enforce<
		ReturnType< $arch_app['initial'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_arch_app_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_arch_app_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_row__sub_arch_app_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_paragraph__title_arch_app_8 = $mol_type_enforce<
		ReturnType< $arch_app['result_count'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_labeler__title_arch_app_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_arch_app_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_paragraph__title_arch_app_11 = $mol_type_enforce<
		ReturnType< $arch_app['result_all_length'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_labeler__title_arch_app_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_arch_app_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_paragraph__title_arch_app_14 = $mol_type_enforce<
		ReturnType< $arch_app['result_meta_length'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_labeler__title_arch_app_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_arch_app_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_paragraph__title_arch_app_17 = $mol_type_enforce<
		ReturnType< $arch_app['result_meta'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_labeler__title_arch_app_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_arch_app_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_paragraph__title_arch_app_20 = $mol_type_enforce<
		ReturnType< $arch_app['result_length'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_labeler__title_arch_app_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_arch_app_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_paragraph__title_arch_app_23 = $mol_type_enforce<
		ReturnType< $arch_app['result_value'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_labeler__title_arch_app_24 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_arch_app_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_row__sub_arch_app_26 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_button_major__title_arch_app_27 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_arch_app_28 = $mol_type_enforce<
		ReturnType< $arch_app['fractal_remove'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_paragraph__title_arch_app_29 = $mol_type_enforce<
		ReturnType< $arch_app['fractal_name'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_labeler__title_arch_app_30 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_arch_app_31 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_paragraph__title_arch_app_32 = $mol_type_enforce<
		ReturnType< $arch_app['fractal_length'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_labeler__title_arch_app_33 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_arch_app_34 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_paragraph__title_arch_app_35 = $mol_type_enforce<
		ReturnType< $arch_app['fractal_result'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_labeler__title_arch_app_36 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_arch_app_37 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_paragraph__title_arch_app_38 = $mol_type_enforce<
		ReturnType< $arch_app['fractal_decode'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_labeler__title_arch_app_39 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_arch_app_40 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_view__sub_arch_app_41 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_arch_app_42 = $mol_type_enforce<
		ReturnType< $arch_app['fractal_list'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_switch__value_arch_app_43 = $mol_type_enforce<
		ReturnType< $arch_app['algorithm'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_switch__options_arch_app_44 = $mol_type_enforce<
		ReturnType< $arch_app['algorithms'] >
		,
		ReturnType< $mol_switch['options'] >
	>
	type $mol_button_major__title_arch_app_45 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_arch_app_46 = $mol_type_enforce<
		ReturnType< $arch_app['fractal_add'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_row__sub_arch_app_47 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	export class $arch_app extends $mol_page {
		initial_length( ): string
		Initial_length( ): $mol_paragraph
		Initial_length_labeler( ): $mol_labeler
		initial( next?: string ): string
		Initial( ): $mol_string
		Initial_labeler( ): $mol_labeler
		Initial_section( ): $mol_row
		result_count( ): string
		Result_count( ): $mol_paragraph
		Result_count_labeler( ): $mol_labeler
		result_all_length( ): string
		Result_all_length( ): $mol_paragraph
		Result_all_length_labeler( ): $mol_labeler
		result_meta_length( ): string
		Result_meta_length( ): $mol_paragraph
		Result_meta_length_labeler( ): $mol_labeler
		result_meta( ): string
		Result_meta( ): $mol_paragraph
		Result_meta_labeler( ): $mol_labeler
		result_length( ): string
		Result_length( ): $mol_paragraph
		Result_labeler( ): $mol_labeler
		result_value( ): string
		Result_value( ): $mol_paragraph
		Result_value_labeler( ): $mol_labeler
		Result( ): $mol_row
		fractal_remove( id: any, next?: any ): any
		Fractal_remove( id: any): $mol_button_major
		fractal_name( id: any): string
		Fractal_name( id: any): $mol_paragraph
		Fractal_name_labeler( id: any): $mol_labeler
		fractal_length( id: any): string
		Fractal_length( id: any): $mol_paragraph
		Fractal_length_labeler( id: any): $mol_labeler
		fractal_result( id: any): string
		Fractal_result( id: any): $mol_paragraph
		Fractal_result_labeler( id: any): $mol_labeler
		fractal_decode( id: any): string
		Fractal_decode( id: any): $mol_paragraph
		Fractal_decode_labeler( id: any): $mol_labeler
		Fractal( id: any): $mol_view
		fractal_list( ): readonly(any)[]
		Fractal_list( ): $mol_list
		algorithm( next?: string ): string
		algorithms( ): ({ 
			'lzw64': string,
			'sub4': string,
			'sub8': string,
			'sub16': string,
			'add3': string,
		}) 
		Algorithm_switch( ): $mol_switch
		fractal_add( next?: any ): any
		Add_fractal( ): $mol_button_major
		Add_alogoritm( ): $mol_row
		title( ): string
		body( ): readonly(any)[]
		foot( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=app.view.tree.d.ts.map